<template>
  <div class="modal fade show custom-modal" id="partyCreated" role="dialog" :class="{'modal-show':showModal}">
    <div class="modal-dialog modal-dialog-centered model-lg ">
      <div class="modal-content">
        <div class="modal-header">
          <img src="@/assets/images/done.png" class="success-img" />
        </div>
        <div class="modal-body text-center pb-0">
            <p class="text-center portrait">Your party has been</P>
            <P class="text-center portrait">successfully generated with</p>
            <p class="paymentSuccess text-center"><span>Party ID : {{partyId?partyId:''}}</span></p>
        </div>
        <div class="col-12 modal-footer pb-5">
          <button type="button" class="btn bgc-btn-primary" data-dismiss="modal" id="hidemodal-done" @click="hideModal();resetData()">Done</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from '@vue/composition-api';
export default {
  name: "PartyCreationSuccessModal",
  props: ["showModal","partyId"],
  components: {
    
  },
  setup(props,context){
    let state=reactive({
    });
    function resetData(){
      context.parent.resetData()
    }
    function hideModal(){
      context.parent.hideModal();
    }
    return{
      resetData,
       hideModal
    }
  }
};
</script>

<style scoped>
.custom-modal {
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
  transform: scale(0);
}
.modal-show {
  display: block;
  transform: scaleY(0) scaleX(0);
  animation: unfoldIn 0.25s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}
.paymentSuccess {
  font-weight: bold;
  color: #000000;
}
.modal-footer {
  justify-content: center;
  border-top: 0 none;
  text-align: center;
  display: block;
}
.modal-body {
  position: relative;
  padding-top: 50px;
  overflow-y: auto;
  overflow-y: hidden;
}
.btn:hover {
  color: #ffffff;
}
.success-img {
  color: white;
  position: relative;
  border: none;
  top: 30px;
  width: 45px;
  height: 45px;
  left: 46%;
}
@media (min-width: 576px) {
  .modal-dialog {
    max-width: 400px;
    margin: 1.75rem auto;
  }
}
@media (min-width: 375px) {
  .portrait {
    width: 100%;
  } /* your css rules for ipad portrait */
}
@media (min-width: 360px) {
  .portrait {
    width: 100%;
  } /* your css rules for ipad portrait */
}
</style>